import {
  WmButton,
  WmProgressIndicator,
  WmProgressMonitor,
  WmProgressSlice
} from "@watermarkinsights/ripple-react";
import { useIntl } from "react-intl";
import translate from "@/i18n/translate";
import { ResponseRateResult } from "../ResponseRateOverview";

interface ResponseRateSectionProps {
  responseRateOverview: ResponseRateResult;
  openDrilldownView: () => void;
}

export const optedOut = (optedOut: number) => {
  return useIntl().formatMessage(
    {
      id: "app.home.responseRateOverview.optedOut"
    },
    { number: optedOut }
  );
};

export const groupLegend = () =>
  useIntl().formatMessage({
    id: "app.home.responseRateOverview.groupLegend"
  });

export const respondedText = () =>
  useIntl().formatMessage({
    id: "app.ces.responseRate.responded"
  });
export const tooltipRespondedText = (students: number) =>
  useIntl().formatMessage(
    { id: "app.home.responseRateOverview.tooltipRespondedText" },
    { students: students }
  );
export const tooltipNotRespondedText = () =>
  useIntl().formatMessage({
    id: "app.home.responseRateOverview.tooltipNotRespondedText"
  });
export const notRespondedText = () =>
  useIntl().formatMessage({
    id: "app.home.responseRateOverview.notResponded"
  });
export const chartLabel = () =>
  useIntl().formatMessage({
    id: "app.home.responseRateOverview.notResponded"
  });
export const responseRatesLabel = () => useIntl().formatMessage({
    id: "app.home.responseRateOverview.responseRates"
  });

export function ResponseRateSection({
  responseRateOverview,
  openDrilldownView
}: ResponseRateSectionProps) {
  return (
    <>
      <div className="response-rates">
        {responseRatesLabel()}
      </div>
      <div className="response-rate-chart">
        <WmProgressMonitor
          id="ces-response-rate"
          groupLegend={groupLegend()}
          breakpoint="10px"
          barLabelsWidth="0"
        >
          <WmProgressIndicator label={" "} aria-label={responseRatesLabel()}>
            <WmProgressSlice
              amount={responseRateOverview.respondedPercentage.toString()}
              popoverText={tooltipRespondedText(responseRateOverview.optedOut)}
              legend={respondedText()}
              popoverTitle={`${responseRateOverview.responded}/${responseRateOverview.total}`}
              title={respondedText()}
            />
            <WmProgressSlice
              amount={responseRateOverview.notRespondedPercentage.toString()}
              popoverText={tooltipNotRespondedText()}
              legend={notRespondedText()}
              popoverTitle={`${responseRateOverview.notResponded}/${responseRateOverview.total}`}
              title={notRespondedText()}
            />
          </WmProgressIndicator>
        </WmProgressMonitor>
      </div>
      <div className="opted-out">{optedOut(responseRateOverview.optedOut)}</div>
      <div className="view-by-course">
        <WmButton
          button-type="textonly"
          icon="f208"
          onClick={() => openDrilldownView()}
        >
          {translate("app.home.responseRateOverview.viewCourseBySection")}
        </WmButton>
      </div>
    </>
  );
}
